import { selectors as requestSelectors } from "redux-request-state";

const commissionsBase = state => state.commissions;
export const isLoadingCommissions = requestSelectors.isLoading( commissionsBase );
export const getCommissions = requestSelectors.getData( commissionsBase );